import React, { useState, createContext, useContext, useEffect } from 'react';
import { isHauptadmin } from '../../lib/globalData';
import dataProvider from '../../lib/dataProvider';
import { useTranslate, usePermissions, List, Create, Edit, Datagrid, SimpleForm, TextField, SelectField, BooleanInput, Button, 
  EditButton, TextInput, SelectInput, ReferenceInput, useRecordContext } from 'react-admin';
import { useInput } from 'ra-core';
import { CheckRecht } from '../../lib/globalData';
import BulkActionButtons from '../../lib/BulkActionButtons';
import CloseToolbar from '../../lib/CloseToolbar';
import NoPagination from '../../lib/NoPagination';
import MailIcon from '@mui/icons-material/MailOutline';
import { Dialog, DialogActions, DialogContent, DialogTitle, Checkbox } from '@mui/material';
import Grid from '@mui/material/Grid';

const statusChoices = [
  { id: 0, name: 'glob.resstatus.stat0' },
  { id: 1, name: 'glob.resstatus.stat1' },
  { id: 2, name: 'glob.resstatus.stat2' },
  { id: 3, name: 'glob.resstatus.stat3' },
  { id: 4, name: 'glob.resstatus.stat4' },
  { id: 5, name: 'glob.resstatus.stat5' },
  { id: 6, name: 'glob.resstatus.stat6' },
]

const receiverChoices = [
  { id: 'G',    name: 'bw.rep.automail.recOpt.0' },
  { id: 'H(S)', name: 'bw.rep.automail.recOpt.1' },
  { id: 'H(L)', name: 'bw.rep.automail.recOpt.2' },
]

const artChoices = [
  { id: 0, name: 'bw.rep.automail.artOpt.0' },
  { id: 1, name: 'bw.rep.automail.artOpt.1' },
  { id: 2, name: 'bw.rep.automail.artOpt.2' },
]

const artChoices2 = [
  { id: 0, name: 'bw.rep.automail.artOpt2.0' },
  { id: 1, name: 'bw.rep.automail.artOpt2.1' },
  { id: 2, name: 'bw.rep.automail.artOpt2.2' },
]

const ParamContext = createContext();

const ParamProvider = ({ children }) => {
  const tr = useTranslate();
  const [data, setData] = useState({ bchan: [], pkat: [], agent: [], config: [], lang: [], land: []});

  useEffect(() => {
    dataProvider.getOne('repAutomail/lists', {id: 0})
    .then(res  => {
      if(res.data.lang){
        res.data.lang.push({ id: 'other', text: tr('bw.rep.automail.other') })
      }
      setData(res?.data)
    })
    // eslint-disable-next-line
  }, []);

  return (
    <ParamContext.Provider value={{data, setData }}>
      {children}
    </ParamContext.Provider>
  );
};

const TestButton = ({ title, filterid, ...rest }) => {
  const record = useRecordContext();
  const [ dialog, setDialog ] = useState([])
  const tr = useTranslate();
  
  if(!record)return null
  const handleTest = () => {
    dataProvider.getOne('repAutomail/test', { id: record.id})
      .then(res => {
        if(res.data){
          setDialog(res.data.data)
        }
      });
  }
  return (
    <>
      <Button variant="text" size="small" label={title} title={title} onClick={handleTest} >
        <MailIcon />
      </Button>
      <Dialog open={dialog.length !== 0} onClose={()=>setDialog([])} >
        <DialogTitle>{tr("bw.rep.automail.test")} </DialogTitle>
        <DialogContent>
          {dialog.map(txt => <div>{txt}</div>)}
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>setDialog([])} color="primary">
            <span>{tr("glob.close")}</span>
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
};

const ConditionField = () => {
  const record = useRecordContext();
  const tr = useTranslate();
  const { data } = useContext(ParamContext)
  if(!record || !data || !data.bchan.length)return
  const statIds = record.resstati.split(',').map(id => parseInt(id, 10))
  const status = statIds.map(id => {
    const choice = statusChoices.find(s => s.id === id)
    if(!choice)return null
    return tr(choice.name)
  }).filter(Boolean)
  const bkIds = record.bookingchannels.split(',').map(id => parseInt(id, 10))
  const bookingChannels = bkIds.map(id => {
    const choice = data?.bchan.find(s => s.id === id)
    if(!choice)return null
    return choice.text
  }).filter(Boolean)
  const zkIds = record.preiskat.split(',').map(id => parseInt(id, 10))
  const ziKats = zkIds.map(id => {
    const choice = data?.pkat.find(s => s.id === id)
    if(!choice)return null
    if(choice.id===-10)return tr('bw.rep.automail.all')
    return choice.text
  }).filter(Boolean)
  const agentIds = (record?.agenten!==''?record.agenten.split(',').map(id => parseInt(id, 10)):[-10])
  const agents = agentIds.map(id => {
    const choice = data?.agent.find(s => s.id === id)
    if(!choice)return null
    if(choice.id===-10)return tr('bw.rep.automail.all')
    return choice.text
  }).filter(Boolean)
  const langIds = record.languages.split(',')
  const languages = langIds.map(id => {
    const choice = data?.lang.find(s => s.id === id)
    if(!choice)return null
    if(choice.id==='All')return tr('bw.rep.automail.all')
    return tr(choice.text)
  }).filter(Boolean)
  return (
    <>
      <div style={{ display: 'flex'}}>
        <div><b>Status: </b></div><div>{status.join(',')}</div>
      </div>
      <div style={{ display: 'flex'}}>
        <div><b>Buchungskanal: </b></div><div>{bookingChannels.join(', ')}</div>
      </div>
      <div style={{ display: 'flex'}}>
        <div><b>Zimmerkategorie: </b></div><div>{ziKats.join(', ')}</div>
      </div>
      <div style={{ display: 'flex'}}>
        <div><b>Agenten: </b></div><div>{agents.join(', ')}</div>
      </div>
      <div style={{ display: 'flex'}}>
        <div><b>Sprachen: </b></div><div>{languages.join(', ')}</div>
      </div>
    </>
  )
}

const ListForm = (props) => {
  const { permissions } = usePermissions();
  const recht = permissions?permissions.reduce((res, r)=>{return r.route==='repBfs'?r.recht:res}, -1):0;
  return (
    <List title="bw.set.prefcountry.title" sort={{ field: 'art', order: 'ASC' }} 
      exporter={isHauptadmin() && props.exporter} pagination={<NoPagination />} perPage={1000} >
      <Datagrid style={{ width: 'auto' }} bulkActionButtons={<BulkActionButtons />} >
        <SelectField source="art" choices={artChoices} />
        { recht>5 &&
          <SelectField source="art2" choices={artChoices2} />
        }
        <TextField source="zeit" />
        <TextField source="titel" />
        <ConditionField label="bw.rep.automail.condition" />
        <TextField source="receiver" />
        <TextField source="lastaction" />
        { recht>5 &&
          <TextField source="lastdatum" />
        }
        {isHauptadmin() &&
          <TextField source="id" textAlign="right" />
        }
        <EditButton label="" />
        <TestButton title='test' {...props} />
      </Datagrid>
    </List>
  )
}

const CheckboxArrayInput = ({ source, choices=[], stringId=false, translateChoice=false, ...props }) => {
  const { field } = useInput({ ...props, source });
  const [value, setValue] = useState([])
  const [allChecked, setAllChecked] = useState(false)

  const handleChange = (key, val) => {
    const v = [...value]
    const idx = v.indexOf(key)
    if(val === true){
      if(idx === -1){
        v.push(key)
      }
    }
    else {
      if(idx > -1){
        v.splice(idx, 1)
      }
    }
    v.sort((a, b) => a - b)
    field.onChange(v.length?v.join(',').replace('NaN,', ''):'')
  }
  
  useEffect(() => {
    var ids = []
    if(stringId === false)ids = field.value.split(',').map(id => parseInt(id, 10))
    else ids = field.value.split(',')
    if(ids.includes(-10) || ids.includes('All')){
      setAllChecked(true)
    }
    else {
      setAllChecked(false)
    }
    setValue(ids)
    // eslint-disable-next-line
  }, [field?.value]);

  const tr = useTranslate();
  if(choices?.length<1)return null
  return (
    <Grid container style={{width:'100%'}} spacing={0} sx={{ mb: '1em', '& .MuiCheckbox-root': { p: '0' } }}>
      <Grid item xs={12} md={12} sx={{mt: '1em', fontSize: '1.2em', fontWeight: 'bold'}}>
        {tr('bw.rep.automail.'+source)}
      </Grid>
      { choices.map(d => {
        const longText = translateChoice===false?d?.text?.length>(allChecked?23:28):tr(d.name).length>(allChecked?23:28)
        if(d.id === -10 || d.id === 'All')return (
          <Grid item xs={12} md={12}>
            <Checkbox checked={value.includes(d.id)} onChange={(ev) => handleChange(d.id, ev.target.checked)} size="large" />
            <span>{tr('bw.rep.automail.all')}</span>
            <span style={{marginLeft: '2em', color: 'grey'}}>{tr('bw.rep.automail.alltxt')}</span>
          </Grid>)
        return (
          <Grid item xs={12} md={longText?8:4} lg={longText?6:3} xl={longText?4:2}>
            <Checkbox checked={value.includes(d.id)} onChange={(ev) => handleChange(d.id, ev.target.checked)} size="large" />
            { translateChoice===false && <span>{allChecked && tr('bw.rep.automail.without')}{d.text}</span>}
            { translateChoice===true && <span>{allChecked && tr('bw.rep.automail.without')}{tr(d.name)}</span>}
          </Grid>)
        }
      ) }
      <Grid item xs={12} md={12} sx={{mt: '1em'}}>
        <hr />
      </Grid>
    </Grid>
  )
}

const ZeitInput = () => {
  const tr = useTranslate();
  return (
    <div style={{display: 'flex'}}>
      <TextInput source="zeit" />
      <span style={{marginTop: '1.8em', marginLeft: '.5em'}}>{tr('bw.rep.automail.zeithelper')}</span>
    </div>
  )
}

const CEForm = () => {
  const { data } = useContext(ParamContext)
  console.log(data)
  if(!data || !data.bchan.length)return
  return (
    <SimpleForm toolbar={<CloseToolbar />}> 
      <SelectInput source="art" choices={artChoices} emptyText='bw.rep.autorep.choose' emptyValue={0} sx={{ minWidth: '16em' }} />
      <SelectInput source="art2" choices={artChoices2} emptyText='bw.rep.autorep.choose' emptyValue={0} sx={{ minWidth: '16em' }} />
      <ZeitInput />
      <ReferenceInput source="id_buchungsblatt" reference="setBookingsheet" perPage={999} >
        <SelectInput optionText='titel' sx={{ minWidth: '16em' }} />
      </ReferenceInput>
      <CheckboxArrayInput source="resstati" choices={statusChoices} translateChoice />
      <CheckboxArrayInput source="bookingchannels" choices={data?.bchan} />
      <CheckboxArrayInput source="preiskat" choices={data?.pkat} />
      <CheckboxArrayInput source="agenten" choices={data?.agent} />
      { data.config?.bwh_gastfeldstorelan !== '0' && 
        <CheckboxArrayInput source="languages" choices={data?.lang} stringId /> 
      }
      { data.config?.msched_country !== '0' && 
        <CheckboxArrayInput source="country" choices={data?.land} /> 
      }
      <CheckboxArrayInput source="receiver" choices={receiverChoices} translateChoice stringId />
      <CheckRecht route="repAutorep" level={2} >
        <BooleanInput source="reset" label="Reset Lastdatum"/>
        <TextInput source="lastdatum" disabled />
      </CheckRecht>
    </SimpleForm>
  )
};

const Automail = {
  list: ({ classes, ...props }) => (
    <ParamProvider>
      <ListForm {...props} classes={classes} />
    </ParamProvider> 
  ),
  
  create: ({classes, ...props }) => (
    <Create {...props} title="bw.set.prefcountry.titleCreate" redirect="list">
      <ParamProvider>
        <CEForm {...props} classes={classes} />
      </ParamProvider> 
    </Create>
  ),
  
  edit: ({ classes, ...props }) => (
    <Edit title="bw.set.prefcountry.titleEdit" mutationMode="pessimistic" {...props}>
      <ParamProvider>
        <CEForm {...props} classes={classes} />
      </ParamProvider> 
    </Edit>
  )
}   
export default Automail